require("@assets/lib/jsencrypt.js");
eval(
  (function (p, a, c, k, e, d) {
    e = function (c) {
      return (
        (c < a ? "" : e(parseInt(c / a))) +
        ((c = c % a) > 35 ? String.fromCharCode(c + 29) : c.toString(36))
      );
    };
    if (!"".replace(/^/, String)) {
      while (c--) d[e(c)] = k[c] || e(c);
      k = [
        function (e) {
          return d[e];
        },
      ];
      e = function () {
        return "\\w+";
      };
      c = 1;
    }
    while (c--)
      if (k[c]) p = p.replace(new RegExp("\\b" + e(c) + "\\b", "g"), k[c]);
    return p;
  })(
    "8 B(2,b){D(C 2=='x'){2=w.n(2)}3 a=1.o.7(2,1.4.5.c(b),{r:1.4.5.c('e')});9 1.4.s.n(a.y)};8 z(2,b){3 q=1.o.6(2,1.4.5.c(b),{r:1.4.5.c('e')});9 q.A(1.4.5)};8 u(a){3 6=h d();6.t(v());p=6.6(R(a));9 p};8 T(m){3 7=h d();7.U(0());3 k=7.7(m);i=S(k).Q(/\\+/g,'%X');9 i};8 0(){3 0='-----Y l j-----';0+='V+f+W';0+='P';0+='H+I';0+='G';0+='E/F/J';0+='N/O+M';0+='K';0+='-----L l j-----';9 0};",
    61,
    61,
    "pub_key|CryptoJS|plainText|var|enc|Utf8|decrypt|encrypt|function|return|encrypted|AES_KEY|parse|JSEncrypt|1234567887654301|||new|data_str|KEY|res|PUBLIC|str|stringify|AES|data_decrypted|decrypted|iv|Base64|setPrivateKey|rsa_decrypt|pri_key|JSON|object|ciphertext|aes_decrypt|toString|aes_encrypt|typeof|if|Avw5eS3UkIPixj4B0mZkhn9VZ9mOgBRgs9Lo|Ihc|GHGXr73iXRhLgqfQhC5dlMisbr3GqnGtPNVOBDYGtGgKS4mpaYzpO60kunooKmdH|3PSU5jrzuzDUEqZvEQaOHfKcUXRx3C61iR9iTnA6YCZLlIX3CnRJzYWCJNRjV|qp|hJXAk3kZvzQjIpzKrYAqHYp|hwIDAQAB|END|EfjuWjJxz02MuWsi|4cKyAfWCegA0G0fGo2aJWqpFrAg25FTDXFf0DRDz|AIEvJu|rcEaJOO94OSQsWzIQSGWM4yoVOVg85YKhW5JlwAHH53Zd8sASLk0ypQv5ze68zeS|replace|decodeURIComponent|encodeURI|rsa_encrypt|setPublicKey|MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1053Mcqn6WH|liJid6|2B|BEGIN".split(
      "|"
    ),
    0,
    {}
  )
);
$(function () {
  var encrypt = $("#encrypt");
  // 全局变量
  let def = {
    show_img_model: null,
    is_set_img_model: false,
    memo: encrypt.attr("data-memo") || "",
    is_review:false, // 是否真实查看
    action: {
      sTableName: encrypt.attr("data-t") || "", //假表名
      iPrid: encrypt.attr("data-id") || "", //当前详情ID
      iColumnId: encrypt.attr("data-col_pid") || "", //主栏目ID
      iSubColumnId: encrypt.attr("data-col") || "", //子栏目ID
      sSelfUrl: location.href, //当前URL
      sRefererUrl: document.referrer || "", //上个页面URL
      iVisit: "", //是否能访问 0-无访问权限 1-有访问权限
      // type: "", //报告下载统计:pdf|zip|image'
      // sPopId: "",
      // iImgUrl: "",
      // iImgUploadType: "",
    },
  };

  // 浏览量统计
  if (P_UserType != "GENERAL" && P_UserType != "TOURIST") {
    def.action.iVisit = 1;
  } else {
    def.action.iVisit = 0;
  }
  window.actionView(def.action);

  var new_report_msg = window.general.fn.cutByWidth(def.memo, 400, 14) || "";
  $(".js_synopsis_prev").html(new_report_msg + "  " + "<span>更多</span>");

  var link_reg_bef = /^http+s?:\/\//i;
  var img_prefix = "https://imgf3.pop-fashion.com";
  //切换图片数据
  var _def = {
    down_list: [],
    page: 0,
  };

  var scroll_item_index = -1;
  // 页面滚动
  $(window).on("scroll", function () {
    var _t = $(window).scrollTop();
    if (_t > 200) {
      $(".js-go-top").show();
    } else {
      $(".js-go-top").hide();
    }

    var layer_list = $(".js-report-content-wrap .indexdiv"),
      layer_list_len = layer_list.length;
    layer_list.each(function (i, n) {
      var this_t = $(this).offset().top;
      if (_t > this_t - 200) {
        scroll_item_index = i;
        $(".js-right-outline-box>ul>li")
          .eq(scroll_item_index)
          .addClass("active")
          .siblings("li")
          .removeClass("active");
      }
    });

    if (!def.is_review) {
      if (layer_list_len >= 6) {
        if (scroll_item_index + 1 >= 6) {
           window.actionRview(def.action);
           def.is_review = true;
        }
      } else if(6 > layer_list_len && layer_list_len > 0) {
        if (scroll_item_index + 1 == layer_list_len) {
           window.actionRview(def.action);
           def.is_review = true;
        }
      }
    }
  });

  $(window).on("resize", function () {
    outlineShowFn();
    reloadSubRepoortItem();
    cloneBannerPic();
    if (def.show_img_model && $(".js-show-pic-section").is(":visible")) {
      def.show_img_model.resetSize();
    }
  });

  $(".js-detail-alert-close").on("click", function () {
    $(".js-detail-alert").hide();
  });

  // 新报告
  if (window.newReportData !== "") {
    var isPdf = $(".report-detail-wrapper .layer-main").data("type") || "";
    var reportData = window.newReportData || [];
    var _html = "";
    var newStyle = document.createElement("style");
    var fontFamilyKey = {
      SourceHanSansSC: ".woff",
      "REEJI-ZhenyanGB2.0": ".ttf",
      Voca: ".ttf",
      Alibaba_PuHuiTi: ".ttf",
      Wenquanyi: ".ttf",
      Sentywen: ".ttf",
      ZCOOL: ".ttf",
      comsc: ".ttf",
      constanz: ".ttf",
    };
    for (var i = 0; i < reportData.length; i++) {
      _html +=
        '<div class="report-sub-content indexdiv" id="index_' +
        reportData[i].sub_id +
        '" data-pageid="' +
        reportData[i].page_id +
        '" style="' +
        renderRpStyle(reportData[i].type, reportData[i].style) +
        'page-break-after: always;">';
      _html +=
        window.is_generate_pdf != undefined && window.is_generate_pdf
          ? '<div class="report-watermark"><a href="' +
            report_href +
            '" title="查看详情"></a></div>'
          : "";
      // if (isPdf) {
      //     _html += '<img src="' + (reportData[i].cover_host + reportData[i].cover) + '" style="width:100%;max-width:none;" />';
      // } else {
      if (reportData[i].backgroundElement) {
        _html += renderRpElement(reportData[i].backgroundElement);
      }
      for (var j = 0; j < reportData[i].elements.length; j++) {
        _html += renderRpElement(reportData[i].elements[j]);
      }
      // }
      _html += "</div>";
    }
    document.head.appendChild(newStyle);
    // if (isPdf) $(".js-report-content-wrap").addClass("ispdf");
    $(".js-report-content-wrap").html(_html);
    if (!isPdf) {
      $(".js-report-content-wrap img").lazyload({
        effect: "fadeIn",
        threshold: 200,
        failurelimit: 10,
      });
    }
    $(".js-hover-wrap img").on(
      "dragstart selectstart contextmenu",
      function (e) {
        e.preventDefault();
        return false;
      }
    );
    var $rpt_player = $("#reportPlayer");
    var reportPlayer;
    $(".js-report-content-wrap")
      .on("click", ".video-play", function () {
        $(".js-report-video-bg").show();
        $(".js-report-video-section").show();
        if ($rpt_player.length) {
          reportPlayer = video_player(
            "reportPlayer",
            $(this).attr("data-videoId")
          );
        }
      })
      .on("click", ".js-preview-img-btn", function (e) {
        if (
          e.target.tagName === "A" &&
          e.target.className.indexOf("js-preview-img-btn") === -1
        )
          return;
        picClick($(this));

        e.stopPropagation();
      })
      .on("click", ".js-download-img-btn", function (e) {
        e.stopPropagation();
        var _src = $(this).attr("data-src") || "";
        var imgUrl = $(this).attr("data-imgurl") || "";
        var sPopId = $(this).attr("data-spopid") || "";
        var rename =
          $(this).attr("data-rename") == undefined ||
          $(this).attr("data-rename") == ""
            ? ""
            : $(this).attr("data-rename");
        if (_src) {
          const src = _src + "?rename=" + rename;
          down(src,{
            type: "image",
            iImgUrl: imgUrl,
            sPopId: sPopId,
            iImgUploadType: sPopId ? 1 : 2,
          });
          var json = JSON.parse($('.js-gio-click').attr("data-gio-imp-attrs"))
          json.report_down_typ = '单张图片'
          gio("track", "report_download", json);
        }
      })
      .on("click", ".mask-warp", function (e) {
        if (
          e.target.tagName === "A" &&
          e.target.className.indexOf("js-preview-img-btn") === -1
        )
          return;
        if ($(this).find(".js-preview-img-btn").length > 0) {
          picClick($(this));
          e.stopPropagation();
        }
      });

    $(".js-report-video-section").on("click", ".close", function () {
      $(".js-report-video-bg").hide();
      $(".js-report-video-section").hide();
      // try { reportPlayer.pauseVideo(); } catch {}
      $rpt_player.html("");
    });

    function picClick(context) {
      var src = context.attr("data-src") || "";
      var id = context.attr("data-id") || "";
      var curid = context.attr("data-curid") || "";
      var t = context.attr("data-t") || "";
      var uuid = context.attr("data-uuid") || "";
      var rename = context.attr("data-rename") || "";
      var aiInfo = context.attr("data-ai") || "";

      showBigPicWithAiTipsWithImgUrl(src,t)
      // if (id.indexOf("col_") > 0) {
      //   var col = id.substring(id.indexOf("col_"), id.length + 4);
      //   if (
      //     col &&
      //     col != 80 &&
      //     col != 81 &&
      //     col != 84 &&
      //     col != 85 &&
      //     col != 117 &&
      //     col != 124
      //   ) {
      //     $(".js-show-pic-section").addClass("status");
      //   } else {
      //     $(".js-show-pic-section").removeClass("status");
      //   }
      // } else {
      //   $(".js-show-pic-section").addClass("status");
      // }

      //禁止浏览器滚动
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", bodyScroll, false); //禁止页面滑动
      // src="https://imgf3.pop-fashion.com/global/images/banner03.jpg";
      if (src != "") {
        modelChangeImg(src);
        $(".js-show-pic-section").show();
        $(".js-show-pic-bg").show();
        var nimg = new Image();
        nimg.src = $(".js-down-img")[0].src;
        $(".js-down-img")[0].onload = function () {
          $(".js-down-img").show();
        };
        $(".js-src").each(function () {
          $(this).attr("data-src", src);
          $(this).attr("data-id", id);
          $(this).attr("data-t", t);
          $(this).attr("data-curid", curid);
          $(this).attr("data-rename", rename);
          $(this).attr("data-ai", aiInfo);
        });
        // downPage(id);
        initDownPage(uuid);
      } else {
        //alert("图片链接为空！");
      }
    }
    function video_player(player_id, vid) {
      var params = {
        styleid: "0",
        client_id: "6304acd0252780d2",
        vid: vid,
        newPlayer: true,
        autoplay: true,
        show_related: false,
      };
      return new YKU.Player(player_id, params);
    }
    function initDownPage(uuid) {
      //放大后图片切换
      _def.down_list = [];
      var status = false,
        imgList = getElementImages(reportData, uuid);
      for (var i = 0; i < imgList.length; i++) {
        if (imgList[i].uuid === uuid) {
          status = true;
          _def.page = i;
          break;
        }
      }
      if (status) {
        for (var i = 0; i < imgList.length; i++) {
          var styleLibrary = imgList[i].styleLibrary || {};
          var src =
            (imgList[i].clip.host || "https://imgf1.pop-fashion.com") +
            (imgList[i].clip.cutout || imgList[i].clip.image);
          var suffix = src.replace(/.+(\.\w+)$/, "$1");
          var aiInfo =
            (imgList[i].attr.aiImg && imgList[i].attr.aiImg.toolsName) || "";
          var aiImgId =
            (imgList[i].attr.aiImg && imgList[i].attr.aiImg.aiId) || "";

          var rename =
            styleLibrary.brand ||
                (imgList[i].attr && imgList[i].attr.brandName)
                  ? "pop_" +
                    (styleLibrary.brand ||
                      (imgList[i].attr && imgList[i].attr.brandName)) +
                    (styleLibrary.brand ? "_" + styleLibrary.brand_id : "") +
                    suffix
                  : "";
          rename = rename.replace(/(\s*&+\s*)/g, '_');
          _def.down_list.push({
            photo: {
              id: styleLibrary.id || aiImgId,
              t: styleLibrary.t || "",
              big: src,
              rename: rename,
              aiInfo: aiInfo || "",
            },
          });
        }
      }
    }
    function getElementImages(elements, uuid) {
      var imgs = [];
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].type === "page") {
          var has = hasElement(elements[i].elements, uuid);
          if (has) {
            imgs = imgs.concat(getElementImages(elements[i].elements, uuid));
            break;
          }
        } else if (elements[i].type === "group") {
          imgs = imgs.concat(getElementImages(elements[i].elements, uuid));
        } else if (
          elements[i].type === "image" &&
          (elements[i].clip.cutout || elements[i].clip.image)
        ) {
          imgs.push(elements[i]);
        }
      }
      return imgs;
    }
    function hasElement(elements, uuid) {
      var has = false;
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].type === "page") {
          var val = hasElement(elements[i].elements, uuid);
          if (val) has = true;
        } else if (elements[i].type === "group") {
          var val = hasElement(elements[i].elements, uuid);
          if (val) has = true;
        } else if (elements[i].uuid === uuid) {
          has = true;
        }
        if (has) break;
      }
      return has;
    }

    function renderRpElement(element) {
      var styleLibrary = element.styleLibrary || {};
      var aiImgId = element.attr
        ? element.attr.aiImg
          ? element.attr.aiImg.aiId
          : 0
        : 0;
      var libraryId = styleLibrary.id
        ? "t_" +
          styleLibrary.t +
          "-id_" +
          styleLibrary.id +
          "-col_" +
          styleLibrary.col
        : aiImgId;
      var _id = styleLibrary.id ? styleLibrary.id : "";
      var t = styleLibrary.t ? styleLibrary.t : "";
      var sPopId = styleLibrary.id
        ? styleLibrary.t + "_" + styleLibrary.id
        : "";
      var big = element.clip
        ? element.clip.cutout || element.clip.image || ""
        : "";
      var suffix = big.replace(/.+(\.\w+)$/, "$1");
      var rename =
        styleLibrary.brand || (element.attr && element.attr.brandName)
          ? "pop_" +
            (styleLibrary.brand || (element.attr && element.attr.brandName)) +
            (styleLibrary.brand ? "_" + styleLibrary.brand_id : "") +
            suffix
          : "";
      rename = rename.replace(/(\s*&+\s*)/g, '_');
      var src = element.clip
        ? (element.clip.host || "https://imgf1.pop-fashion.com") +
          (element.clip.cutout || element.clip.image)
        : "";
      var srcQ = src.replace(
        /imgf1\.pop-fashion\.com/,
        "imgwf1.pop-fashion.com"
      );
      var aiInfo = element.attr
        ? element.attr.aiImg
          ? element.attr.aiImg.toolsName
          : ""
        : "";
      /*
          * public $ai_tools_dict = [1 => 'Midjourney', 2 => 'Stable Diffusion', 3 => 'AI智绘',];
        public $other_tools_dict = [1 => '二次创作', 2 => '修图工具'];
        public $ai_img_type_dict = [1 => '款式', 2 => '图案', 3 => '灵感', 4 => '面料/织片', 5 => '辅料', 6 => '云图模版', 7 => '线稿图', 8 => '工艺/细节',
        ];
        *
        *
        * */
      // var isSupportWebp = document.createElement("canvas").toDataURL("image/webp").indexOf("data:image/webp") === 0;
      // if (isSupportWebp) {
      //   srcQ = src ? src + '!q30' : '';
      // }
      if (element.type === "text") {
        if (element.style.fontFamily === "")
          element.style.fontFamily = "inherit";
        if (navigator.userAgent.indexOf("Firefox") > -1) {
          if (
            element.style.fontFamily === "inherit" ||
            element.style.fontFamily === "SourceHanSansSC-Regular.woff"
          ) {
            element.style.fontFamily = "SourceHanSansSC-Regular.woff";
            // element.style.width = parseFloat(element.style.width) + element.text.toString().replace(/(<\/?\w+>)/g, '').length * 0.8;
            element.style.letterSpacing =
              parseFloat(element.style.letterSpacing) - 0.8;
            if (element.text.toString().indexOf("-") > -1) {
              var str = element.text.toString().match(/-/g) || [];
              element.style.width =
                parseFloat(element.style.width) + str.length * 0.01;
            }
          }
        } else if (
          navigator.userAgent.indexOf("Safari") > -1 &&
          navigator.userAgent.indexOf("Chrome") === -1
        ) {
          if (
            element.style.fontFamily === "inherit" ||
            element.style.fontFamily === "SourceHanSansSC-Regular.woff"
          ) {
            element.style.fontFamily = "SourceHanSansSC-Regular.woff";
            // element.style.width = parseFloat(element.style.width) + element.text.toString().replace(/(<\/?\w+>)/g, '').length * 1;
            element.style.letterSpacing =
              parseFloat(element.style.letterSpacing) - 1;
            if (element.text.toString().indexOf("-") > -1) {
              var str = element.text.toString().match(/-/g) || [];
              element.style.width =
                parseFloat(element.style.width) + str.length * 0.5;
            }
          }
          element.style.width = Math.ceil(element.style.width);
        }
      }
      var _html =
        '<div class="element-warp ' +
        (element.type === "background" ? "paved" : "") +
        '">';
      var eleStyle = JSON.parse(JSON.stringify(element.style));
      eleStyle.paddingLeft = 0;
      eleStyle.paddingRight = 0;
      eleStyle.paddingTop = 0;
      eleStyle.paddingBottom = 0;
      _html +=
        '<div class="element element-' +
        element.type +
        '" style="' +
        renderRpStyle(element.type, eleStyle) +
        '">';
      if (element.type === "text") {
        var textStyle = {
          paddingLeft: element.style.paddingLeft,
          paddingRight: element.style.paddingRight,
          paddingTop: element.style.paddingTop,
          paddingBottom: element.style.paddingBottom,
        };
        _html +=
          '<div class="text" style="' +
          renderRpStyle(element.type, textStyle) +
          '">' +
          element.text +
          "</div>";
        loadFontFace(element.style.fontFamily);
        // var textFontFamilys = htmlDecodeByRegExp(element.text.toString()).match(/(?<=font-family:\s*['"]?)[\w\d-\.]+(?=['"]?\s*;)/g);
        var textFontFamilys = htmlDecodeByRegExp(element.text.toString()).match(
          /font-family:\s*['"]*[\w\d-\.]+['"]*;*/g
        );
        if (textFontFamilys) {
          textFontFamilys = textFontFamilys.map(function (v) {
            return v
              .replace(/font-family:\s*['"]*/g, "")
              .replace(/['"]*;*/g, "");
          });
        }
        textFontFamilys &&
          textFontFamilys.forEach(function (family) {
            var familyKey = family.split(/-/);
            if (familyKey.length > 1)
              familyKey = familyKey.splice(0, familyKey.length - 1);
            familyKey = familyKey.join("-");
            if (familyKey === "inherit") return;
            var fontFamily = family + (fontFamilyKey[familyKey] || "");
            loadFontFace(fontFamily);
          });
      }
      if (
        (element.type === "image" || element.type === "background") &&
        (element.clip.cutout || element.clip.image)
      ) {
        var imgStyle = {
          width: element.clip.w ? element.clip.w + "px" : "auto",
          height: element.clip.h ? element.clip.h + "px" : "auto",
          left: element.clip.x + "px",
          top: element.clip.y + "px",
          transform:
            "scale(" +
            element.clip.scale * element.style.fliph +
            ", " +
            element.clip.scale * element.style.flipv +
            ")",
        };
        if (
          element.type !== "background" &&
          !(element.attr && element.attr.videoId)
        ) {
          _html +=
            '<div class="img-wrap preview-img js-preview-img-btn" data-uuid="' +
            element.uuid +
            '" data-id="' +
            libraryId +
            '" data-t="' +
            t +
            '" data-src="' +
            src +
            '" data-rename="' +
            rename +
            '" data-ai="' +
            aiInfo +
            '">';
        } else {
          _html += '<div class="img-wrap">';
        }
        if (isPdf && imgStyle.width !== "auto" && imgStyle.height !== "auto") {
          var w = parseFloat(imgStyle.width);
          var h = parseFloat(imgStyle.height);
          var l = parseFloat(imgStyle.left);
          var t = parseFloat(imgStyle.top);
          var sw = w * element.clip.scale;
          var sh = h * element.clip.scale;
          var x = l + (w - sw) / 2;
          var y = t + (h - sh) / 2;
          if (element.style.fliph < 0)
            x = parseFloat(element.style.width) - (sw + x);
          if (element.style.flipv < 0)
            y = parseFloat(element.style.height) - (sh + y);
          var testStyle = {
            width: "100%",
            height: "100%",
            backgroundRepeat: "no-repeat",
            backgroundSize:
              parseFloat(sw.toFixed(2)) +
              "px " +
              parseFloat(sh.toFixed(2)) +
              "px",
            backgroundPosition:
              parseFloat(x.toFixed(2)) +
              "px " +
              parseFloat(y.toFixed(2)) +
              "px",
            backgroundImage: "url('" + srcQ + "')",
            transform:
              "scale(" + element.style.fliph + ", " + element.style.flipv + ")",
            borderRadius: "inherit",
          };
          _html +=
            '<div class="hover-wrap js-hover-wrap"><div style="' +
            styleToString(testStyle) +
            '"></div></div>';
        } else {
          _html +=
            '<div class="hover-wrap js-hover-wrap"><img ' +
            (isPdf ? "src" : "data-original") +
            '="' +
            srcQ +
            '" style="' +
            styleToString(imgStyle) +
            '" ondragstart="return false;" oncontextmenu="return false;" onselectstart="return false;" /></div>';
        }
        _html += "</div>";
      }
      if (element.type === "svg") {
        var svgStyle = {
          paddingLeft: element.style.paddingLeft,
          paddingRight: element.style.paddingRight,
          paddingTop: element.style.paddingTop,
          paddingBottom: element.style.paddingBottom,
        };
        _html +=
          '<svg style="' +
          renderRpStyle(element.type, svgStyle) +
          '" viewBox="0 0 ' +
          element.style.w +
          " " +
          element.style.h +
          '" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">';
        for (var i = 0; i < element.paths.length; i++) {
          _html +=
            '<path d="' +
            element.paths[i].path +
            '" fill="' +
            element.paths[i].fill +
            '"></path>';
        }
        _html += "</svg>";
      }
      if (element.type === "group") {
        for (var i = 0; i < element.elements.length; i++) {
          _html += renderRpElement(element.elements[i]);
        }
      }
      _html += "</div>";
      if (element.type === "image") {
        var maskWarpStyle = {
          width: element.style.width + "px",
          height: element.style.height + "px",
          left: element.style.left + "px",
          top: element.style.top + "px",
          transform: "rotate(" + element.style.rotate + "deg)",
        };
        if (
          element.type === "image" &&
          !(element.attr && element.attr.videoId) &&
          (element.clip.cutout || element.clip.image)
        ) {
          _html +=
            '<div class="mask-warp" style="' +
            styleToString(maskWarpStyle) +
            '" data-uuid="' +
            element.uuid +
            '" data-curid="' +
            _id +
            '" data-id="' +
            libraryId +
            '" data-t="' +
            t +
            '" data-src="' +
            src +
            '" data-rename="' +
            rename +
            '" data-ai="' +
            aiInfo +
            '">';
            if(element.style.height < 210){
              _html +=
              '<div class="img-tool small" style="transform: translate(-50%, -50%) rotate(' +
              -element.style.rotate +
              'deg);">';
            }else{
              _html +=
              '<div class="img-tool" style="transform: translate(-50%, -50%) rotate(' +
              -element.style.rotate +
              'deg);">';
            }

          _html +=
            '<a class="tool-preview js-preview-img-btn" href="javascript:;" title="查看大图" data-uuid="' +
            element.uuid +
            '" data-curid="' +
            _id +
            '" data-id="' +
            libraryId +
            '" data-t="' +
            t +
            '" data-src="' +
            src +
            '" data-rename="' +
            rename +
            '" data-ai="' +
            aiInfo +
            '"></a>';
          if (P_UserType != "GENERAL" && P_UserType != "TOURIST") {
            _html +=
              '<a class="tool-download js-download-img-btn" href="javascript:;" title="下载" data-uuid="' +
              element.uuid +
              '" data-curid="' +
              _id +
              '" data-id="' +
              libraryId +
              '" data-t="' +
              t +
              '" data-src="' +
              src +
              '" data-rename="' +
              rename +
              '" data-imgurl="' +
              element.clip.image +
              '" data-spopid="' +
              sPopId +
              '" data-ai="' +
              aiInfo +
              '"></a>';
          }
          if (element.attr && !element.attr.link && styleLibrary.id) {
            // 款式图数据兼容
            element.attr.link =
              styleLibrary.link ||
              "/details/style/t_" +
                styleLibrary.t +
                "-id_" +
                styleLibrary.id +
                "-col_" +
                styleLibrary.col;
          }
          _html += `<div class="ai_view" data-t="${styleLibrary.t}" data-src="${src}"><span><i class="ai_txt"></i></span></div>`
          createHoverView(styleLibrary.t,src)

          _html += "</div>";
        } else {
          _html +=
            '<div class="mask-warp" style="' +
            styleToString(maskWarpStyle) +
            '">';
        }
        if (
          element.type === "image" &&
          element.attr &&
          element.attr.brandName
        ) {
          var position = element.attr.position || {};
          var brandNameStyle = {
            transform: "rotate(" + -element.style.rotate + "deg)",
          };
          brandNameStyle[position.h || "left"] = (position.x || 6) + "px";
          brandNameStyle[position.h === "right" ? "left" : "right"] = "auto";
          brandNameStyle[position.v || "bottom"] = (position.y || 6) + "px";
          brandNameStyle[position.v === "bottom" ? "top" : "bottom"] = "auto";
          _html +=
            '<a class="brand-name" href="' +
            ("/search/?key=" +
              encodeURIComponent(encodeURIComponent(element.attr.brandName))) +
            '" target="_blank" style="' +
            styleToString(brandNameStyle) +
            '">' +
            element.attr.brandName +
            "</a>";
        }
        if (element.type === "image" && element.attr && element.attr.videoId) {
          var videoPlayStyle = {
            transform: "rotate(" + -element.style.rotate + "deg)",
          };
          _html +=
            '<button class="video-play" title="播放" data-videoId="' +
            element.attr.videoId +
            '" style="' +
            styleToString(videoPlayStyle) +
            '"><i></i>视频</button>';
        }
        if (
          element.type === "image" &&
          element.attr &&
          element.attr.copyrightType
        ) {
          _html += '<div class="original-icon"></div>';
        }
        _html += "</div>";
      }
      _html += "</div>";
      return _html;
    }
    function renderRpStyle(type, styles) {
      var style = {};
      var needUnitStr = [
        "width",
        "height",
        "top",
        "left",
        "paddingTop",
        "paddingLeft",
        "paddingRight",
        "paddingBottom",
        "marginTop",
        "marginLeft",
        "marginRight",
        "marginBottom",
        "borderWidth",
        "fontSize",
        "borderRadius",
        "letterSpacing", 'borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomLeftRadius', 'borderBottomRightRadius'
      ];
      var textStyleStr = [
        "paddingTop",
        "paddingLeft",
        "paddingRight",
        "paddingBottom",
      ];
      var transformStr = ["rotate", "fliph", "flipv"];
      var shadowStr = ["shadowColor", "shadowBlur", "shadowH", "shadowV"];
      var noNeedUnitStr = ["x", "y", "w", "h"];
      for (var key in styles) {
        if (
          styles[key] === "auto" ||
          styles[key] === "normal" ||
          styles[key] === "100%"
        ) {
          // 属性兼容
          style[key] = styles[key];
        } else if (needUnitStr.indexOf(key) !== -1) {
          if (textStyleStr.indexOf(key) !== -1) {
            if (type === "text" || type === "svg")
              style[key] = styles[key] + "px";
          } else {
            style[key] = styles[key] + (styles[key] && styles[key].toString().includes("px") ? "" : "px");
          }
        } else if (noNeedUnitStr.indexOf(key) !== -1) {
          continue;
        } else if (key === "opacity") {
          style[key] = styles[key] / 100;
        } else if (transformStr.indexOf(key) !== -1) {
          style["transform"] = "rotate(" + styles["rotate"] + "deg)";
        } else if (shadowStr.indexOf(key) !== -1) {
          if (
            styles["shadowH"] == 0 &&
            styles["shadowV"] == 0 &&
            styles["shadowBlur"] == 0
          )
            continue;
          style["boxShadow"] =
            styles["shadowH"] +
            "px " +
            styles["shadowV"] +
            "px " +
            styles["shadowBlur"] +
            "px " +
            styles["shadowColor"];
        } else if (key === "lineHeight" && styles[key] > 10) {
          style[key] = styles[key] + "px";
        } else if (key === "fontFamily") {
          style[key] =
            styles[key] === "inherit"
              ? styles[key]
              : "'" + styles[key].replace(/\.\w+$/, "") + "'";
        } else if (key === "textStrokeWidth" || key === "textStrokeColor") {
          style["text-stroke"] =
            styles["textStrokeWidth"] + "px " + styles["textStrokeColor"] ||
            "transparent";
          style["-webkit-text-stroke"] =
            styles["textStrokeWidth"] + "px " + styles["textStrokeColor"] ||
            "transparent";
        } else {
          style[key] = styles[key];
        }
      }
      return styleToString(style);
    }
    function styleToString(styles) {
      var style = "";
      for (var i in styles) {
        var key = i.replace(/([A-Z])/g, function ($1) {
          return "-" + $1.toLowerCase();
        });
        if (isPdf && key === "letter-spacing") {
          style += key + ":0;";
        } else if (
          key === "background" &&
          styles[i] &&
          styles[i].length === 9
        ) {
          style += key + ":" + hex8ToRgba(styles[i]) + ";";
        } else {
          style += key + ":" + styles[i] + ";";
        }
        if (key === "transform" && styles[i]) {
          style += "-webkit-transform:" + styles[i] + ";";
        } else if (
          key === "background" &&
          styles[i] &&
          styles[i].indexOf("linear-gradient") !== -1
        ) {
          var matchStr = styles[i]
            .match(/^linear-gradient\((.*)\)$/)[1]
            .split(/deg,\s?|%,\s?|%/)
            .filter(function (v) {
              return v;
            })
            .map(function (v, i) {
              if (i === 0) {
                return 90 - parseFloat(v) + "deg";
              }
              return v + "%";
            })
            .toString();
          style += key + ":-webkit-linear-gradient(" + matchStr + ");";
        }
      }
      return style;
    }
    function hex8ToRgba(bgColor) {
      var color = bgColor.slice(1);
      var rgba = [
        parseInt("0x" + color.slice(0, 2)),
        parseInt("0x" + color.slice(2, 4)),
        parseInt("0x" + color.slice(4, 6)),
        parseInt("0x" + color.slice(6, 8)),
      ];
      return "rgba(" + rgba.toString() + ")";
    }
    // 字体加载 (font.woff)
    function loadFontFace(fontFamily) {
      if (fontFamily === "inherit") return;
      var name = fontFamily ? fontFamily.replace(/\.\w+$/, "") : "";
      if (newStyle.innerText.indexOf(name) !== -1) return;
      newStyle.appendChild(
        document.createTextNode(
          "@font-face {font-family: '" +
            name +
            "';src: url(https://staticf1.pop-fashion.com/static/report-font/" +
            fontFamily +
            ");}"
        )
      );
      // if (!fontFamily || fontFamily === 'inherit' || document.fonts.check(`12px '${name}'`)) return;
      // try {
      //   var font = new FontFace(
      //     name,
      //     "url(https://imgf3.pop-fashion.com/global/report-font/" + fontFamily + ")",
      //   );
      //   font.load().then(() => {
      //     document.fonts.add(font);
      //   });
      // } catch(err) {
      //   console.log('字体加载失败', err);
      // }
    }
    // html解码
    function htmlDecodeByRegExp(str) {
      var s = "";
      if (str.length == 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      return s;
    }

    /* 文字行高兼容 */
    var userAgent = navigator.userAgent.toLocaleLowerCase();
    var chromeV = userAgent.match(/chrome\/\d+/);
    if (chromeV) chromeV = parseFloat(chromeV[0].split("/")[1]);
    var hasSe = userAgent.match(/se 2.x/);
    var hasQQbrowser = userAgent.match(/qqbrowser/);
    if ((hasSe || hasQQbrowser) && chromeV && chromeV < 78)
      $(".js-report-content-wrap").addClass("compatible");

    /* 页面定位 */
    var id = getQueryString("searchId");
    function getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    }
    if (id != null && id != undefined) {
      document.getElementById("search-loading").style.display = "block";
      setTimeout(function () {
        var el = document.getElementById(id);
        if (el) el.scrollIntoView();
        document.getElementById("search-loading").style.display = "none";
      }, 2000);
    }
  }
  function bodyScroll(event) {
    event.preventDefault();
  }

  $(".js-i-left").on("click", function () {
    --_def.page;
    if (_def.page < 0) {
      _def.page = _def.down_list.length - 1;
    }
    var src = _def.down_list[_def.page].photo.big;
    var id = _def.down_list[_def.page].photo.id;
    var t = _def.down_list[_def.page].photo.t || "";
    var rename = _def.down_list[_def.page].photo.rename;
    var aiInfo = _def.down_list[_def.page].photo.aiInfo;

    if (src.indexOf("fm.pop-fashion.com") != -1) {
      src = img_prefix + src.split("fm.pop-fashion.com")[1];
    }
    src = src ? (link_reg_bef.test(src) ? src : img_prefix + src) : "";

    modelChangeImg(src);
    showBigPicWithAiTipsWithImgUrl(src,t)
    $(".js-src").each(function () {
      $(this).attr("data-src", src);
      $(this).attr("data-id", id);
      $(this).attr("data-curid", id);
      $(this).attr("data-t", t);
      $(this).attr("data-rename", rename);
      $(this).attr("data-ai", aiInfo);
    });
    $(".js-show-pic-section").addClass("status");
    if (id.toString().indexOf("col") > 0) {
      $(".js-recommend").show();
    } else {
      $(".js-recommend").hide();
    }
    /* $('.js-down-box').hide(); */
  });
  $(".js-i-right").on("click", function () {
    ++_def.page;
    if (_def.page >= _def.down_list.length) {
      _def.page = 0;
    }
    var src = _def.down_list[_def.page].photo.big;
    var id = _def.down_list[_def.page].photo.id;
    var t = _def.down_list[_def.page].photo.t || "";
    var rename = _def.down_list[_def.page].photo.rename;
    var aiInfo = _def.down_list[_def.page].photo.aiInfo;
    // src = src ? (src.indexOf('http:') < 0 ? (img_prefix + src) : src) : '';

    if (src.indexOf("fm.pop-fashion.com") != -1) {
      src = img_prefix + src.split("fm.pop-fashion.com")[1];
    }
    src = src ? (link_reg_bef.test(src) ? src : img_prefix + src) : "";

    modelChangeImg(src);
    showBigPicWithAiTipsWithImgUrl(src,t)
    $(".js-src").each(function () {
      $(this).attr("data-src", src);
      $(this).attr("data-id", id);
      $(this).attr("data-curid", id);
      $(this).attr("data-t", t);
      $(this).attr("data-rename", rename);
      $(this).attr("data-ai", aiInfo);
    });
    $(".js-show-pic-section").addClass("status");
    if (id.toString().indexOf("col") > 0) {
      $(".js-recommend").show();
    } else {
      $(".js-recommend").hide();
    }
    /* $('.js-down-box').hide(); */
  });
  //
  function modelChangeImg(src) {
    if (def.is_set_img_model == false) {
      def.is_set_img_model = true;
      def.show_img_model = new scaleImg({
        box: ".js-show-pic-section",
        src: src,
      });
    } else {
      def.show_img_model.changeImg(src);
    }
  }

  // function getDownload(params, imgUrl, src) {
  //   $.ajax({
  //     "url": "/details/style/",
  //     type: "post",
  //     dataType: "json",
  //     data: params,
  //     success: function (data) {
  //       if (data.code == 1) {
  //         alert("图片已失效");
  //         return false;
  //       }
  //       var sign = encrypt?.data("sign");
  //       var ndata = JSON.parse(aes_decrypt(data.data, sign));
  //       var id = ndata.id || "";
  //       var t = ndata.t || "";
  //       var col = ndata.col || "";
  //       var download_type = ndata["downloadType"] || "";
  //       if (download_type != "") {
  //         setDownloadDom(download_type, t, id, col, imgUrl);
  //       } else {
  //         down(src, t, id, col);
  //         // 下载统计
  //         // const sPopId = t + '_' + id;
  //         // actionDown("image", imgUrl, sPopId);
  //       }
  //     }
  //   })
  // };

  // 看大图下载
  $(".js-download-btn2").on("click", function (event) {
    event.stopPropagation();
    // var id = $(this).attr("data-id") || "";
    // let imgUrl = $(this).attr("data-imgurl") || "";
    var _src = $(this).attr("data-src") || "";
    var curid = $(this).attr("data-curid") || "";
    var curt = $(this).attr("data-t") || "";
    var rename =
      $(this).attr("data-rename") == undefined ||
      $(this).attr("data-rename") == ""
        ? ""
        : $(this).attr("data-rename");
    if (_src) {
      var src = rename.length > 0 ? _src + "?rename=" + rename : _src;
      var sPopId = curid != "" && curt != "" ? curt + "_" + curid : "";
      down(src, {
        type: "image",
        iImgUrl: _src.split("com")[1],
        sPopId: sPopId,
        iImgUploadType: sPopId ? 1 : 2,
      });
      var json = JSON.parse($('.js-gio-click').attr("data-gio-imp-attrs"))
      json.report_down_typ = '单张图片'
      gio("track", "report_download", json);
    }
  });

  // 下载报告pdf / 全部图片
  $(".js-download-pdf").on("click", function (event) {
    event.stopPropagation();
    event.preventDefault();
    var _src = $(this).attr("data-downurl") || "";
    if (_src) {
      down(_src,{
        type:'pdf',
      });
      var json = JSON.parse($('.js-gio-click').attr("data-gio-imp-attrs"))
      json.report_down_typ = '上报PDF'
      gio("track", "report_download", json);
    }
  });
  $(".js-download-all").on("click", function (event) {
    event.stopPropagation();
    event.preventDefault();
    var _src = $(this).attr("data-downurl") || "";
    if (_src) {
      down(_src,{
        type:'zip'
      });
      var json = JSON.parse($('.js-gio-click').attr("data-gio-imp-attrs"))
      json.report_down_typ = '全部图片'
      gio("track", "report_download", json);
    }
  });

  var down = function (dl_link,action) {
    if (P_UserType == "TRIAL") {
      $(".js-detail-alert").show();
      return;
    }
    if (dl_link) {
      Object.assign(def.action,action)
      window.actionDown(def.action);

      var rename =  $('#encrypt').attr('data-rename')
      rename = rename.replace(/[\s&?]/g, '_');
      var fileType = dl_link.split('.').pop();

          // 替换为你的链接

      if(dl_link.split('?rename=').length <= 1){
        if(rename && rename.length > 0 && !dl_link.includes('?rename=')){
          dl_link += '?rename=' + rename + '.' + fileType;
        }else if(rename && rename.length > 0 && dl_link.includes('?rename=')){
          dl_link +=  rename + '.' + fileType;
        }
      }



      window.location.href = "/download/dlsingle?dl_link=" + encodeURIComponent(dl_link) + '&' + Math.random();
    }
  };

  //回到顶部
  $(".js-go-top").on("click", function () {
    $("html,body").animate(
      {
        scrollTop: "0",
      },
      700
    );
  });

  $('.js-aiplan-btn').on('click', function () {
    gio('track', 'AIPlanning_click', {
      site_name: 'CMF',
      AccountId: P_UserId,
      pop_id: def.action.iPrid
    });
  });

  if (!localStorage.getItem('aiplan_guide')) {
    $('.js-aiplan-guide').show().prev().css('opacity', 0);
  }
  $('.js-aiplan-guide').on('click', 'i', function() {
    localStorage.setItem('aiplan_guide', '1');
    $(this).parent().hide().prev().css('opacity', 1);
  });

  var ele = $(".js-report-detail-right");
  function outlineShowFn() {
    var screenWidth = window.innerWidth;
    if (screenWidth > 1500) {
      ele.css("right", "0px");
      ele.removeClass("hidden");
    } else {
      ele.css("right", "-330px");
      ele.addClass("hidden");
    }
  }
  outlineShowFn();

  $(".js-show-outline-btn").on("click", function () {
    var ele = $(".js-report-detail-right");
    var rightValue = ele.css("right");
    if (rightValue === "-330px") {
      ele.find(".show_box").hide();
      ele.find(".hide_box").show();
      ele.css("right", "0px");
    } else {
      ele.find(".show_box").show();
      ele.find(".hide_box").hide();
      ele.css("right", "-330px");
    }
  });


  function showBigPicWithAiTipsWithImgUrl(src,t){

    var itemArr = getItemArrWithT(t)

    $('.aigc-view .ai_more').attr('data-t',t)
    $('.aigc-view .ai_more').attr('data-src',src)
    let ul_ele = $('.aigc-view ul')
    var html1 = ''
    for(let i = 0; i < itemArr.length; i++){//  <div class="look"><span>操作教程，去看看</span><i class="ai_icon"></i></div>
        let item = itemArr[i]
        html1 += ` <li class="ai_${item.id} ai_${i + 1} ${item.type}" data-name="${item.title}" data-src="${src}" data-desc="${item.desc}" data-url="${item.url}">
                    <span class="title"><i class="ai_icon"></i></span>
                    <span class="des">${item.title}</span>
                    <div class="hover-view">
                        <div class="video-view">
                            <video loop muted playsinline autoplay>
                                <source src="${item.path}" type="video/mp4">
                            </video>
                        </div>
                        <div class="h-title">${item.title}</div>
                        <div class="desc">${item.desc}</div>
                        <div class="btn-view" data-url="${item.url}" data-src="${src}" data-name="${item.title}">
                            <div class="content">
                            <a>
                            <div class="pic"><img src="${src}" alt=""></div>
                            <span>立即体验</span>
                            </a>
                            </div>
                        </div>

                    </div>
                </li>`
    }
    ul_ele.html(html1)

    $('.aigc-view').show()

  }

function getItemArrWithT(t){
  var itemArr = [
    { title: 'AI改款', type: 'normal', desc: '一句话输入需求，即可高效完成改款生成，让设计表达更自由。', path: asset_url + '/static/images/aigc/video/ai_video_chat.mp4', url: 'https://cmf.pop-aigc.com/chat?chatImgUrl=', id: 'chat' },
    {title:'相似款衍生',type:'normal',url:'https://cmf.pop-aigc.com/aigc/1/6?imgUrl=',desc:'在原款基础上进行全款 / 局部的相似款设计，快速实现爆款衍生或系列款设计。',path: asset_url + '/static/images/aigc/video/ai_video_1.mp4',id:'6'},
    {title:'款式融合',type:'normal',url:'https://cmf.pop-aigc.com/aigc/1/34?imgUrl=',desc:'将原图与参照图,在设计风格上进行自由融合,生成全新款式图',path:asset_url + '/static/images/aigc/video/ai_video_3.mp4',id:'34'},
    {title:'AI描稿',type:'normal',url:'https://cmf.pop-aigc.com/aigc/2/29?imgUrl=',desc:'一键将低画质图转化为连续超高清平面图',path:asset_url + '/static/images/aigc/video/ai_video_8.mp4',id:'29'},
    {title:'涂抹消除',type:'normal',url:'https://cmf.pop-aigc.com/aigc/4/41?imgUrl=',desc:'涂抹局部区域，智能消除内容，可用于消除款式零部件、局部去水印等操作场景',path:asset_url + '/static/images/aigc/video/ai_video_9.mp4',id:'41'},
    {title:'AI褪底',type:'normal',url:'https://cmf.pop-aigc.com/aigc/4/19?imgUrl=',desc:'复杂场景一键抠图，简单便捷',path:asset_url + '/static/images/aigc/video/ai_video_10.mp4',id:'19'}]

  if(t == 'styles'){
      itemArr =  [
        { title: 'AI改款', type: 'styles', desc: '一句话输入需求，即可高效完成改款生成，让设计表达更自由。', path: asset_url + '/static/images/aigc/video/ai_video_chat.mp4', url: 'https://cmf.pop-aigc.com/chat?chatImgUrl=', id: 'chat' },
        {title:'相似款衍生',type:'styles',desc:'在原款基础上进行全款 / 局部的相似款设计，快速实现爆款衍生或系列款设计。',path:asset_url + '/static/images/aigc/video/ai_video_1.mp4',url:'https://cmf.pop-aigc.com/aigc/1/6?imgUrl=',id:'6'},
        {title:'款式配色',type:'styles',desc:'可对原款的整款 / 局部 进行精准色号调整，并保持原款的面料材质不变，高效实现一款多色、精确改色设计操作',path:asset_url + '/static/images/aigc/video/ai_video_2.mp4',url:'https://cmf.pop-aigc.com/aigc/1/36?imgUrl=',id:'36'},
        {title:'款式融合',type:'styles',desc:'将原图与参照图,在设计风格上进行自由融合,生成全新款式图',path:asset_url + '/static/images/aigc/video/ai_video_3.mp4',url:'https://cmf.pop-aigc.com/aigc/1/34?imgUrl=',id:'34'},
        {title:'款生线稿',type:'styles',desc:'完美还原原款图片的线条结构，将原款图片转为黑白线稿图',path:asset_url + '/static/images/aigc/video/ai_video_4.mp4',url:'https://cmf.pop-aigc.com/aigc/1/12?imgUrl=',id:'12'}]

  }
  if(t == 'graphicitem'){
      itemArr = [
          { title: 'AI改款', type: 'graphic', desc: '一句话输入需求，即可高效完成改款生成，让设计表达更自由。', path: asset_url + '/static/images/aigc/video/ai_video_chat1.mp4', url: 'https://cmf.pop-aigc.com/chat?chatImgUrl=', id: 'chat' },
          {title:'相似图衍生',type:'graphic',desc:'在原款基础上进行全款 / 局部的相似图设计，快速实现爆款衍生或系列款设计。',path:asset_url + '/static/images/aigc/video/ai_video_5.mp4',url:'https://cmf.pop-aigc.com/aigc/2/15?imgUrl=',id:'15'},
          {title:'图案融合',type:'graphic',desc:'将原图与参照图在设计风格上进行自由融合，生成全新图案花型',path:asset_url + '/static/images/aigc/video/ai_video_6.mp4',url:'https://cmf.pop-aigc.com/aigc/2/42?imgUrl=',id:'42'},
          {title:'图案配色',type:'graphic',desc:'只需一张图案，便可获得无限配色方案的新图案，还可根据指定颜色进行配色改色',path:asset_url + '/static/images/aigc/video/ai_video_7.mp4',url:'https://cmf.pop-aigc.com/aigc/2/30?imgUrl=',id:'30'}]

  }
  return itemArr
}


function createHoverView(t,src){

  var itemArr = getItemArrWithT(t)

    let _html = ''
    _html += '<ul>'
        for(let i = 0; i < itemArr.length; i++){
            let item = itemArr[i]
            _html += `<li class="ai_${item.id} ai_${i} ${item.type}" data-name="${item.title}" data-url="${item.url}" data-src="${src}">
                        <span class="title"><i class="ai_icon"></i></span>
                        <span class="des">${item.title}</span>
                    </li>`
        }

    _html += '</ul>'
    $('.ai_hover_view').html(_html)
    if(itemArr.length <= 5) {
      $('.aigc-view .ai_more').hide();
    }else{
      $('.aigc-view .ai_more').show();
    }

}

$('body').on('mouseenter','.aigc-view ul li',function(){

    $(this).children('.hover-view').addClass('show')
    var _bigSrc;
    var _col = $('.js-bigbox').attr("data-col");
    if(_col == 82 || _col == 231 || _col ==232 || _col == 233 || _col == 234 || _col == 120){
        _bigSrc = $('.js-bigbox').attr("data-mp");
    }else{
        _bigSrc = $('.js-bigbox').attr("src");
    }
    $(this).find('.btn-view .pic img').attr('src',_bigSrc)
    if($(this).find('.video-view video')){
        $(this).find('.video-view video')[0].currentTime = 0;
    }

}).on('mouseleave','.aigc-view ul li',function(){
    if(!$('.hover-view:hover').length){
        $(this).children('.hover-view').removeClass('show')
    }
})

$('.ai_hover_view').on('mouseenter',function(){

}).on('mouseleave',function(){
    if(!$('.report-content-wrap .element-warp .img-tool .ai_view:hover').length){
        $('.ai_hover_view').css({
            top: -1000,
            left: -1000
        })
        $('.report-content-wrap .element-warp').removeClass('cur')
    }

})

$('body').on('mouseenter','.report-box',function(){
    $(this).addClass('cur')
}).on('mouseleave','.report-box',function(){
    if(!$('.ai_hover_view:hover').length){
        $(this).removeClass('cur')
    }
})

$('body').on('mouseenter','.report-content-wrap .element-warp',function(){
    $(this).addClass('cur')
}).on('mouseleave','.report-content-wrap .element-warp',function(){

    if(!$('.ai_hover_view:hover').length){
        $(this).removeClass('cur')
    }
})

$('body').on('mouseenter','.report-content-wrap .element-warp .img-tool .ai_view',function(){

    var position = $(this).position();
    var scrollTop = $(window).scrollTop();
    var scrollLeft = $(window).scrollLeft();
    var _top = $(this).offset().top - scrollTop - 72
    var _left = $(this).offset().left -scrollLeft + 36
    $('.ai_hover_view').css({
        top:_top,
        left:_left
    })
    let _t = $(this).attr('data-t')
    let _src = $(this).attr('data-src')
    createHoverView(_t,_src)
}).on('mouseleave','.report-content-wrap .element-warp .img-tool .ai_view',function(){
    if(!$('.ai_hover_view:hover').length){
        $('.ai_hover_view').css({
            top: -1000,
            left: -1000
        })
    }
})

$('body').on('mouseenter','.report-box .tool-div .ai_view',function(){

    var position = $(this).position();
    var scrollTop = $(window).scrollTop();
    var scrollLeft = $(window).scrollLeft();
    var _top = $(this).offset().top - scrollTop - 72
    var _left = $(this).offset().left -scrollLeft + 51
    $('.ai_hover_view').css({
        top:_top,
        left:_left
    })
    let _t = $(this).attr('data-t')
    let _src = $(this).attr('data-src')
    createHoverView(_t,_src)
}).on('mouseleave','.report-box .tool-div .ai_view',function(){
    if(!$('.ai_hover_view:hover').length){
        $('.ai_hover_view').css({
            top: -1000,
            left: -1000
        })
    }
})


function changeToAiWindowWith(name,url,src){

    if(src){
      src = src.split('?')[0] ? src.split('?')[0] : ""
    }
    let _col = $('#encrypt').attr('data-col')
    gio("track","aifunction_clic",{aifunction_name:name,col_id:_col})
    var popUser =JSCookie.get('POP_USER');
    var pid = JSCookie.get('pidtt')
    let hasImgUrl = url.includes('?imgUrl')
    if(!src){
        var jumpUrl = url + (popUser ? '?popuser=' + popUser + (pid ? '&pid=' + pid : '')  : '' + (pid ? '?pid=' + pid : ''));
        window.open(jumpUrl, '_blank');
        return
    }

    src = encodeURIComponent(encodeURIComponent(src))
    var jumpUrl = url + src + (popUser ? '&popuser=' + popUser : '') + (pid ? '&pid=' + pid : '');
    window.open(jumpUrl, '_blank'); // 跳转页面
}


$('body').on('click','.ai_hover_view ul li',function(e){

    e.stopPropagation()
    let url = $(this).attr('data-url')
    var _bigSrc = $(this).attr('data-src')
    var name = $(this).attr('data-name')
    changeToAiWindowWith(name,url,_bigSrc)
})

$('body').on('click','.aigc-view ul li .btn-view',function(e){

  e.stopPropagation()
  let url = $(this).attr('data-url')
  var _bigSrc = $(this).attr('data-src')
  var name = $(this).attr('data-name')
  changeToAiWindowWith(name,url,_bigSrc)

})

$('body').on('click','.ai_view ul li',function(e){
    e.stopPropagation()
    var name = $(this).attr('data-name')
    let url = $(this).attr('data-url')
    var _bigSrc = $(this).attr('data-src')
    changeToAiWindowWith(name,url,_bigSrc)

})

$('body').on('click','.aigc-view ul li',function(e){
    e.stopPropagation()
    let url = $(this).attr('data-url')
    var _bigSrc = $(this).attr('data-src')
    var name = $(this).attr('data-name')
    changeToAiWindowWith(name,url,_bigSrc)

  })
  $('body').on('click','.aigc-view .ai_more',function(e){
    e.stopPropagation()
    var _bigSrc = $(this).attr("data-src")
    var url = ''
    var _t = $(this).attr("data-t")
    if(_t == 'styles'){
        url = 'https://cmf.pop-aigc.com/aigc/1/5';
    }else if(_t == 'graphicitem'){
      url =  'https://cmf.pop-aigc.com/aigc/2/29?imgUrl='
    }else{
      url = 'https://cmf.pop-aigc.com/aigc/1/5'
    }
    changeToAiWindowWith('更多',url,_bigSrc)


  })


    $('body').on('click','.aigc-view ul li .hover-view .look',function(){
      $('.video-mask').show()
    })
    $('body').on('click','.video-mask .video-view .js_video_close',function () {
        $('.video-mask').hide()
    })




  /****************************  -----沉浸浏览----  ******************************/

  /* 1. 进入全屏（支持多种前缀） */
  function requestFullscreen(el = document.documentElement) {
    const fn =
      el.requestFullscreen ||
      el.webkitRequestFullscreen ||
      el.mozRequestFullScreen ||
      el.msRequestFullscreen;
    if (fn) fn.call(el);
  }
  /* 2. 退出全屏 */
  function exitFullscreen() {
    const fn =
      document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.mozCancelFullScreen ||
      document.msExitFullscreen;
     if (fn) fn.call(document)

  }
  /* 通用事件名集合 */
  const FS_EVENTS = [
    'fullscreenchange',
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'MSFullscreenChange'
  ];

  FS_EVENTS.forEach(evt =>
    document.addEventListener(evt, onFullscreenChange)
  );

  function onFullscreenChange () {
    // 1. 判断当前是否还处于全屏
    const stillInFs = !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );

    // 2. 如果已经退出（!stillInFs），立即做你想做的事
    if (!stillInFs) {
      console.log('已退出全屏 → 现在可以执行后续逻辑');
      // '已退出全屏 → 现在可以执行后续逻辑'
    escFullScreen();
    }
  }

  function changeToFullScreen(){
    $('.report-detail-wrapper .layer-main').addClass('full-screen');
    $('.detail_header_box').addClass('full-screen');
    // $('.report-detail-wrapper .report-detail-right .report-full-screen').addClass('full-screen');
    // $('.report-detail-wrapper .report-detail-right .operation-box').addClass('full-screen');
    $('.report-detail-wrapper .report-detail-right').addClass('full-screen');
    $('.report-detail-wrapper .report-crumbs-nav').addClass('full-screen');
    $('.full-control').addClass('full-screen');
    $('.report-detail-wrapper').addClass('full-screen');
    $('body').addClass('full-screen');
    full_index = 0;
    isShowTips = false;
    isClick = false;
    cloneBannerPic();
    requestFullscreen();
  }
  function escFullScreen(){
    $('.report-detail-wrapper .layer-main').removeClass('full-screen');
    $('.detail_header_box').removeClass('full-screen');
    // $('.report-detail-wrapper .report-detail-right .report-full-screen').addClass('full-screen');
    // $('.report-detail-wrapper .report-detail-right .operation-box').addClass('full-screen');
    $('.report-detail-wrapper .report-detail-right').removeClass('full-screen');
    $('.report-detail-wrapper .report-crumbs-nav').removeClass('full-screen');
    $('.full-control').removeClass('full-screen');
    $('.report-detail-wrapper').removeClass('full-screen');
    $('.full-control').removeClass('full-screen');
    $('.report-content-wrap').css('transform','translateX(0%)');
    $('.report-content-wrap .report-sub-content').css({'transform':`scale(1)`,'-webkit-transform':`scale(1)`,'margin':'0 0 0 -32px'});
    $('.report-content-wrap .report-sub-content .element-warp .img-tool').css({'transform':`scale(1)`,'-webkit-transform':`scale(1)`});
    $('body').removeClass('full-screen');
    $('.report-content').removeClass('full-screen');
    full_index = 0;
    isShowTips = false;
    isClick = false;
  }
  var full_index = 0;
  var isClick = false;
  function fullScreenChangePageWithType(type){
    if(isClick){
      return;
    }
    isClick = true;
    setTimeout(function(){
      isClick = false;
    }, 100);
    let len = $('.layer-main.full-screen .report-content-wrap .report-sub-content').length;
    if($('.layer-main.full-screen .report-content-wrap .bannerpic').length > 0){
      len = len + 1;
    }
    let element = $('.layer-main.full-screen .report-content-wrap');
    if(type === 'next'){
      if(full_index >= len - 1){
        showFullScreenTips('已是最后一页');
        return;
      }
      full_index++;
      let late_x = full_index * 100;
      element.css({'transform':`translateX(-${late_x}%)`,'-webkit-transform':`translateX(-${late_x}%)`});
      return
    }else if(type === 'prev'){
      if(full_index <= 0){
        showFullScreenTips('已是第一页');
        return;
      }
      full_index--;
      let late_x = full_index * 100;
      element.css({'transform':`translateX(-${late_x}%)`,'-webkit-transform':`translateX(-${late_x}%)`});
      return
    }


  }
  $('.full-control .small-view').on('click', function () {
    $('.full-control').toggleClass('show');
  });
  $('.full-control .big-view').on('click','.prev-btn', function () {
   fullScreenChangePageWithType('prev');
  }).on('click','.next-btn', function () {
   fullScreenChangePageWithType('next');
  }).on('click','.esc-btn', function () {
    exitFullscreen();
  }).on('click','.close-btn', function () {
    $('.full-control').removeClass('show');
  });



  let pic_ele = document.querySelector('.report-detail-wrapper .report-detail-left .bannner-title-box .bannerpic')?.cloneNode(true);
  var reportContentWrap = document.querySelector('.report-detail-wrapper .report-content-wrap');
  if (reportContentWrap && pic_ele) reportContentWrap.insertBefore(pic_ele, reportContentWrap.children[0]);
  let lazyImg = $('.layer-main .report-content-wrap .bannerpic img')
  lazyImg.length && lazyImg.lazyload({
      effect: "show",
      failure_limit: 12,
      threshold: 500,
      event: "sporty",
  });
  lazyImg.trigger("sporty")
  function cloneBannerPic(){
    if($('.layer-main .report-content-wrap .bannerpic').length == 0){
      return;
    }
    let clone_w = document.querySelector('.report-detail-wrapper .report-detail-left .bannner-title-box .bannerpic').clientWidth;
    let clone_h = document.querySelector('.report-detail-wrapper .report-detail-left .bannner-title-box .bannerpic').clientHeight;
    let screen_w = window.innerWidth;
    let screen_h = window.innerHeight;
    let scale_x = screen_w/clone_w;
    let scale_y = screen_h/clone_h;
    let scale = scale_x > scale_y ? scale_y : scale_x;
    document.querySelector('.layer-main .report-content-wrap .bannerpic').style.margin = `0 calc(50% - ${clone_w/2}px)`
    document.querySelector('.layer-main .report-content-wrap .bannerpic').style.transform = `scale(${scale})`;
    document.querySelector('.layer-main .report-content-wrap .bannerpic').style.width = clone_w + 'px';
  }
  cloneBannerPic();

  $('body').on('click','.report-detail-wrapper .report-detail-right .report-full-screen', function () {

    full_index = 0;
    // showFullScreenTips();
    changeToFullScreen();
    reloadSubRepoortItem();

    $(document).on('keydown', function (e) {
      if(!$('.layer-main').hasClass('full-screen')){
          return;
      }
      switch (e.which) {
        case 37://'← 左'
           console.log('← 左');
           fullScreenChangePageWithType('prev');
           break;
        case 38: //'↑ 上'
           console.log('↑ 上');
           fullScreenChangePageWithType('prev');
           break;
        case 39: //'→ 右'
           console.log('→ 右');
           fullScreenChangePageWithType('next');
           break;
        case 40: //'↓ 下'
           console.log('↓ 下');
           fullScreenChangePageWithType('next');
           break;
        case 27: //'ESC'
           console.log('ESC');
           exitFullscreen();
           break;
        default:
           return;               // 其他键不处理
      }
      e.preventDefault();              // 需要时阻止默认行为
    });

  });


function reloadSubRepoortItem(){
    if( $('.layer-main.full-screen .report-content-wrap .report-sub-content').length == 0 ){
      return;
    }

    let lazyLoadImg =  $('.layer-main.full-screen .report-content-wrap .report-sub-content .element .img-wrap img')
      lazyLoadImg.length && lazyLoadImg.lazyload({
          effect: "show",
          failure_limit: 12,
          threshold: 500,
          event: "sporty"
        });
        lazyLoadImg.trigger("sporty")

    $('.layer-main.full-screen .report-content-wrap .report-sub-content').each(function(){

      let width = $(this).css('width');
      let height = $(this).css('height');
      let screen_w = window.innerWidth;
      let screen_h = window.innerHeight;
      let num_w = parseInt(width.replace('px',''));
      let num_h = parseInt(height.replace('px',''));
      let scale_x = screen_w/num_w;
      let scale_y = screen_h/num_h;
      let scale = scale_x > scale_y ? scale_y : scale_x;
      let unScale = 1 / scale;
      console.log(width,height,screen_w,screen_h,screen_w/num_w,screen_h/num_h);
      let margin_x = `calc((100% - ${width}) / 2)`;
      let margin_y = `calc((100vh - ${height}) / 2)`;

      $(this).css({'margin-left':margin_x,'margin-top':margin_y,'margin-right':margin_x,'margin-bottom':margin_y});
      $(this).css({'transform':`scale(${scale})`,'-webkit-transform':`scale(${scale})`});

      $(this).find('.element-warp .img-tool').css({'transform':`scale(${unScale})`,'-webkit-transform':`scale(${unScale})`});

    })
}

var isShowTips = false;
function showFullScreenTips(str) {
  if(isShowTips){
    return;
  }
  isShowTips = true;
  if(str){
     $('.full-control').addClass('show');
    $(document.body).append('<div class="full-alert"><div class="view"><i class="full_svg"></i><span>' + str + '</span></div></div>');

    let t = setTimeout(() => {
        $('.full-alert').addClass('show');
        clearTimeout(t);
    }, 50);
    let timer = setTimeout(function () {
      $('.full-alert').removeClass('show');
      clearTimeout(timer);
    }, 2950);
    let t1 = setTimeout(() => {
        $('.full-alert').remove();
        clearTimeout(t1);
        isShowTips = false;
    }, 3000);

  }
  // else{
  //   let html = ` <div class="full-tips">
  //                 <div class="view">
  //                   <div class="i_view">
  //                   <i class="full_svg prev"></i>
  //                   </div>

  //                   <span style="margin:0 16px 0 4px;">返回上一页</span>
  //                   <div class="i_view">
  //                     <i class="full_svg next"></i>
  //                   </div>

  //                   <span style="margin-left:4px;">切换下一页</span>
  //                   <span class="esc">Esc</span>
  //                   <span>退出全屏</span>
  //                 </div>
  //               </div>`
  //   $(document.body).append(html);
  //      let t = setTimeout(() => {
  //       $('.full-tips').addClass('show');
  //       clearTimeout(t);
  //   }, 50);

  //   let timer = setTimeout(function () {
  //      $('.full-tips').removeClass('show');
  //      clearTimeout(timer);
  //   }, 3950);
  //   let t1 = setTimeout(() => {
  //       $('.full-tips').remove();
  //       clearTimeout(t1);
  //       isShowTips = false;
  //   }, 4000);

  // }
}

 /****************************  -----沉浸浏览end----  ******************************/



});
